<script setup lang="ts">
import ViRatingBar from "@/components/elements/vi-rating-bar/vi-rating-bar.vue";
import { ISDGRating } from "@/modules/profile/services/data/sdg/sdg.interface";

defineProps<{
  data: ISDGRating;
}>();
</script>

<template>
  <div class="impact-card">
    <PxPanel>
      <div class="impact-card__header">
        <div class="impact-card__header-title">
          <span class="px-panel__title">SDG Impacts</span>
          <span>Updated: May 2025</span>
        </div>
        <!-- <PxButton>
          <PxIcon size="16" name="download" />
          Download Full Report
        </PxButton> -->
      </div>
      <div class="impact-card__content">
        <span>Vested Impact Rating</span>
        <span>{{ data.rating }}</span>
        <span class="impact-card__content-rating">{{ data.score }}</span>
        <div class="impact-card__rating-bar">
          <span>-100</span>
          <ViRatingBar
            size="large"
            type="double"
            :negative="data.negativeImpact"
            :positive="data.positiveImpact"
          />
          <span>+100</span>
        </div>
        <span>Vested Impact Score</span>
      </div>
      <div class="impact-card__footer">
        <div class="impact-card__footer-icons">
          <span>TOP POSITIVELY IMPACTED SDG'S</span>
          <div class="impact-card__footer-images">
            <img
              v-for="sdg of data.topPositivelyImpactedSDGs"
              :key="sdg"
              :src="`/img/sdg/${sdg}.png`"
            />
          </div>
        </div>
        <div class="impact-card__footer-details">
          The Sustainable Development Goals (SDGs) are 17 global objectives
          established by the United Nations in 2015 to end poverty, protect the
          planet, and promote peace and prosperity by 2030.
        </div>
        <div class="impact-card__footer-links">
          <span>How impact is measured</span>
          <span class="impact-card__footer-links-vi">
            Data provided by
            <span>Vested Impact</span>
          </span>
        </div>
      </div>
    </PxPanel>
  </div>
</template>

<style lang="scss" scoped>
.impact-card {
  width: 100%;
  margin-top: 24px;

  &__header {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }

  &__header-title {
    display: flex;
    flex-direction: column;
  }

  &__header-title .px-panel__title {
    line-height: 1 !important;
  }

  &__footer-icons > span {
    font-size: 12px;
    font-weight: 600;
  }

  &__header-title > span:nth-child(2) {
    font-size: 1rem;
    color: #8b8fa1;
    font-weight: 500;
    letter-spacing: -0.1px;
  }

  &__header :deep(.px-icon) {
    margin-right: 8px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px 0;
    background-color: #fafafa;
    border-radius: 4px;
    margin-top: 24px;
    margin-bottom: 24px;
  }

  &__content > span:first-child {
    font-size: 16px;
  }

  &__content > span:nth-child(2) {
    font-size: 4rem;
    line-height: 64px;
    font-weight: 600;
    color: #272740;
    margin-bottom: 16px;
  }

  &__content-rating {
    font-size: 18px;
    font-weight: 600;
    color: #272740;
  }

  &__rating-bar {
    width: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    font-size: 8px;
    color: #8b8fa1;
  }

  &__footer-icons {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 24px;
  }

  &__footer-links {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  &__footer-details {
    color: #8b8fa1;
    font-size: 16px;
    margin-bottom: 24px;
  }

  &__footer-images {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
  }

  &__footer-images img {
    display: block;
    width: 48px;
  }

  &__footer-links-vi {
    font-style: italic;
  }
}
</style>
